import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY } from '../../constants/globalConstants'
import visa from '../../assets/img/payment_icon/visa.png'
import { getFormattedTime, formatDecimal } from '../../utils/helper'

function ExtendDetails(props) {
    const { extendedDetails } = props
    // const [discountedTotal, setDiscountedTotal] = useState(0)


    useEffect(() => {

    }, [EMPTY_ARRAY])


    

    

    return (
        <div>
            
            {extendedDetails?.length > 0 && <div className='m-2 collapse hide' id="collapseExample">
                    <table className="table table-borderless table-sm">
                        {extendedDetails?.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        <span className="text-primary">{index=='0'?'Started':'Extended'}</span>
                                        <small className="d-block text-muted">	<i className="far fa-clock"></i> {`${getFormattedTime(item?.length, false)} ${Number(item?.length) > 1 ? 'HRS' : Number(item?.length) == 1 ? 'HR' :'MM'}`}</small>
                                    </td>
                                    <td className="text-end">{`$${formatDecimal(item?.grand_total)}`}<br />
                                        <img src={visa} style={{height: '10px', padding: '0'}}  alt="" />
                                    </td>


                                    {/* <td className='text-start'>
                                        {index=='0'?'Started':'Extended'} 
                                    </td>
                                    <td className='text-center'>
                                        {`${getFormattedTime(item?.length, false)} ${Number(item?.length) > 1 ? 'HRS' : Number(item?.length) == 1 ? 'HR' :'MM'}`}
                                    </td>
                                    <td className='text-end mb-1'>
                                    {`$${formatDecimal(item?.grand_total)}`}
                                        {index == 0 ? `$${item?.total}` : `$${formatDecimal(Number(item?.total) - Number(extendedDetails?.[index-1]?.total))}`}
                                    </td> */}
                                </tr>
                            )
                        })}
                    </table>
                    
                </div>}
        </div>
    )
}

ExtendDetails.propTypes = {
    dispatch: PropTypes.func,
    className: PropTypes.string,
    extendedDetails: PropTypes.array,
}

ExtendDetails.defaulProps = {
    dispatch: noop,
    className: '',
    extendedDetails: EMPTY_ARRAY,
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(ExtendDetails)